import {BaseContainerModel} from "../../../base-container.model";
import {
  bl_alg_cc_conversation_event_RowClass,
  bl_alg_cc_conversation_agent_squad_link_RowClass
} from "../../../../dbschema";

export class ConversationAgentSquadContainerModel extends BaseContainerModel {
  bl_alg_cc_conversation_agent_squad_link: bl_alg_cc_conversation_agent_squad_link_RowClass = new bl_alg_cc_conversation_agent_squad_link_RowClass();
  bl_alg_cc_conversation_events: bl_alg_cc_conversation_event_RowClass[] = [];
}
